// extracted by mini-css-extract-plugin
module.exports = {"display":"DateTimeDisplay_display__3XDRv"};